import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCartFilters,
  clearCartFilters,
} from "../../../store/slices/adminCartSlice";
import debounce from "lodash/debounce";
import { clearUserCartThunk } from "store/thunks/adminCartThunks";

export const useCartListFilters = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.cart);

  const debouncedSearch = useCallback(
    debounce((searchTerm) => {
      dispatch(setCartFilters({ search: searchTerm }));
    }, 500),
    [dispatch]
  );

  const handleFilterChange = (key, value) => {
    dispatch(setCartFilters({ [key]: value }));
  };

  const handleSearch = (searchTerm) => {
    debouncedSearch(searchTerm);
  };

  const handleReset = () => {
    dispatch(clearCartFilters());
  };

  return {
    filters,
    handleFilterChange,
    handleSearch,
    handleReset,
  };
};

export const useCartActions = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const clearCart = async (cartId, reason) => {
    setLoading(true);
    try {
      await dispatch(clearUserCartThunk({ cartId, reason })).unwrap();
      return { success: true };
    } catch (error) {
      return { success: false, error };
    } finally {
      setLoading(false);
    }
  };

  return {
    clearCart,
    loading,
  };
};
